@layer module {
.legacy-tooltip {
            z-index: 10020;
    }
} // layer module










@layer app {
.legacy-tooltip {
            max-width: calc(100vw - $size-20);
    }
} // layer app
